import moment from 'moment';
import { RiskResult, ScenarioData, ScenarioType } from './types';
import { TFunction } from 'i18next';
import { getScenarioType } from './utils/TransposedData';

export const RowHeader = (
  riskResultData: RiskResult[],
  t: TFunction,
  indicator: number,
  timeStamp: string
): ScenarioData[] => {
  const data: ScenarioData[] = [];
  const scenarioType = getScenarioType(riskResultData, indicator, timeStamp);

  const premiumSummaryScenarioTypes: ScenarioType[] = ['Default'];
  const riskProfileScenarioTypes: ScenarioType[] = [
    'LegacyPoolIndicatorOne',
    'LegacyPoolIndicatorBefore2020'
  ];
  const premiumAndTaxScenarioTypes: ScenarioType[] = [
    'Default',
    'LegacyPoolIndicatorZero2020To2026',
    'LegacyPoolIndicatorBefore2020'
  ];

  data.push({
    rowHeader: t('Approved-Volumes'),
    rowHeaderKey: 'approvedVolumes',
    subRows: [
      {
        rowHeader: t('Count'),
        key: 'totalLoanCount'
      },
      {
        rowHeader: t('Amount'),
        key: 'totalLoanAmount'
      }
    ]
  });

  if (premiumSummaryScenarioTypes.includes(scenarioType)) {
    data.push({
      rowHeader: t('Premium-Summary'),
      rowHeaderKey: 'premiumSummary',
      subRows: [
        {
          rowHeader: t('Base-Premium-Rate'),
          key: 'basePremiumRate'
        },
        {
          rowHeader: t('Premium-Discount'),
          key: 'premiumDiscount'
        },
        {
          rowHeader: t('Premium-Rate'),
          key: 'premiumFlatRatePercent'
        }
      ]
    });
  }

  if (riskProfileScenarioTypes.includes(scenarioType)) {
    data.push({
      rowHeader: t('Risk Profile Summary'),
      rowHeaderKey: 'riskProfileSummary',
      subRows: [
        {
          rowHeader: t('5-Year-Non-Adjusted-Claims-Rate'),
          key: 'expectedClaimRatePercent'
        },
        {
          rowHeader: t('5-Year-Adjusted-Claims-Rate'),
          key: 'adjustedEstimatedClaimRatePercent'
        }
      ]
    });
  }

  if (premiumAndTaxScenarioTypes.includes(scenarioType)) {
    const subRows = [];
    if (scenarioType !== 'Default') {
      subRows.push({
        rowHeader: t('Premium-Rate'),
        key: 'premiumFlatRatePercent'
      });
    }
    data.push({
      rowHeader:
        scenarioType === 'Default'
          ? t('Premium-and-Tax-Summary')
          : t('Premium-Calculation-and-Tax-Summary'),
      subRows: [
        ...subRows,
        {
          rowHeader: t('Premium-Amount'),
          key: 'mliPremiumDueAmount'
        },
        {
          rowHeader: t('Ontario-Tax'),
          key: 'ontarioProvincialSalesTaxDueAmount'
        },
        {
          rowHeader: t('Quebec-Tax'),
          key: 'quebecProvinceSalesTaxDueAmount'
        },
        {
          rowHeader: t('Manitoba-Tax'),
          key: 'manitobaProvinceSalesTaxDueAmount'
        },
        {
          rowHeader: t('Saskatchewan-Tax'),
          key: 'saskatchewanProvinceSalesTaxDueAmount'
        },
        {
          rowHeader: t('PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Total'),
          key: 'calculateTotal'
        }
      ]
    });
  }

  return data;
};
